import {
  Badge,
  Divider,
  Group,
  Paper,
  SimpleGrid,
  Text,
  Title,
} from "@mantine/core";
import moment from "moment/moment";
import React from "react";
import { useState } from "react";
import {
  BuildingWarehouse,
  Calendar,
  CalendarOff,
  CalendarTime,
  Cash,
  Check,
  Clock,
  User,
  Users,
  X,
} from "tabler-icons-react";
import ModalWrapper from "../ModalWrapper/ModalWrapper";
import { SpecificView } from "./SpecificView";

const SpecificJobView = ({ data }) => {
  const [applicantModal, setApplicantModal] = useState(false);
  const [openedApplicant, setOpenedApplicant] = useState({});
  console.log("openedApplicant", openedApplicant);

  return (
    <Paper>
      <ModalWrapper
        opened={applicantModal}
        setOpened={setApplicantModal}
        title="Applicant Details"
        InternalComponent={
          <SpecificView
            name={openedApplicant?.user?.displayName || "N/A"}
            description={openedApplicant?.coverLetter || "N/A"}
            type={openedApplicant?.industryType?.typeName || "N/A"}
            date={openedApplicant?.appliedDate || "N/A"}
            status={openedApplicant?.appliedStatus || "N/A"}
          />
        }
      />
      <Group position="center">
        <Title order={1} className="text-dark" align="center">
          {data?.jobTitle}
        </Title>

        {/* <Badge
          size="xl"
          color={data.state === "active" ? "green" : "red"}
          my="sm"
        >
          {data.state}
        </Badge> */}
      </Group>

      <Group mt="md">
        <Title order={5}>Location:</Title>
        <Title order={5} style={{ color: "rgb(0,0,0,0.6)" }}>
          {data?.empLocation?.locationName + ", " + data?.empLocation?.city}
        </Title>
        {/* {data.appliedCandidates.length > 0 ? (
          data.appliedCandidates.length === 1 ? (
            <Group spacing={5}>
              <User color="green" />
              <Text weight={500}>1 Application</Text>
            </Group>
          ) : (
            <Group spacing={5}>
              <Users color="green" />
              <Text weight={500}>
                {data.appliedCandidates.length.toLocaleString()} Applications
              </Text>
            </Group>
          )
        ) : (
          <Text weight={500}>No Applications</Text>
        )} */}
      </Group>

      {data.appliedCandidates.length > 0 && (
        <>
          <Divider my={"lg"} />
          <Paper>
            <Title
              order={4}
              style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}
              my={"sm"}
            >
              Applied Candidates
            </Title>
            <Group spacing={10}>
              {data.appliedCandidates?.map((applicant, index) => {
                return (
                  <Badge
                    size="lg"
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setOpenedApplicant(applicant);
                      setApplicantModal(true);
                    }}
                    // mx={"sm"}
                  >
                    <Group>
                      <User size={20} />
                      <Text>{applicant?.user?.displayName || "N/A"}</Text>
                    </Group>
                  </Badge>
                );
              })}
            </Group>
          </Paper>
        </>
      )}
      <Divider my={"lg"} />
      {/* <div> */}
      <Title order={4} style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}>
        Job Details
      </Title>
      <SimpleGrid
        verticalSpacing={0}
        cols={2}
        breakpoints={[
          { maxWidth: "md", cols: 2, spacing: "md" },
          { maxWidth: "sm", cols: 2, spacing: "sm" },
          { maxWidth: "xs", cols: 1, spacing: "sm" },
        ]}
      >
        <Group noWrap pt="md">
          <CalendarTime size={30} />
          <div>
            <Title
              order={5}
              style={{
                color: "rgb(0,0,0,0.7)",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              Posted At
            </Title>
            <Text>
              <b>{moment(data.postingDate).format("LL")}</b>
            </Text>
          </div>
        </Group>

        <Group noWrap pt="md">
          <CalendarOff size={30} />
          <div>
            <Title
              order={5}
              style={{
                color: "rgb(0,0,0,0.7)",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              Expires At
            </Title>
            <Text>
              <b>{moment(data.expiryDate).format("LL")}</b>
            </Text>
          </div>
        </Group>

        <Group noWrap pt="md">
          {data.remotely ? (
            <Check size={30} color="green" />
          ) : (
            <X size={30} color="red" />
          )}

          <Title
            order={5}
            style={{
              color: "rgb(0,0,0,0.7)",
              fontWeight: "700",
              marginBottom: "0px",
            }}
          >
            Remote
          </Title>
        </Group>

        <Group noWrap pt="md">
          {data.relocation ? (
            <Check size={30} color="green" />
          ) : (
            <X size={30} color="red" />
          )}
          <Title
            order={5}
            style={{
              color: "rgb(0,0,0,0.7)",
              fontWeight: "700",
              marginBottom: "0px",
            }}
          >
            Relocation
          </Title>
          <Group spacing={3} noWrap></Group>
        </Group>
        <Group noWrap pt="md">
          {data.veteranShare ? (
            <Check size={30} color="green" />
          ) : (
            <X size={30} color="red" />
          )}{" "}
          <Title
            order={5}
            style={{
              color: "rgb(0,0,0,0.7)",
              fontWeight: "700",
              marginBottom: "0px",
            }}
          >
            Veteran Share
          </Title>
        </Group>
        <Group noWrap pt="md">
          {data.commission ? (
            <Check size={30} color="green" />
          ) : (
            <X size={30} color="red" />
          )}{" "}
          <Title
            order={5}
            style={{
              color: "rgb(0,0,0,0.7)",
              fontWeight: "700",
              marginBottom: "0px",
            }}
          >
            Commission
          </Title>
        </Group>

        <Group noWrap pt="md">
          <Cash color="green" size={30} />
          <div>
            <Title
              order={5}
              style={{
                color: "rgb(0,0,0,0.7)",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              Salary
            </Title>
            <Text>
              ${data?.minSalary} - ${data?.maxSalary} (Per{" "}
              {data?.salaryRange === "monthly" ? "Month" : "Hour"})
            </Text>
          </div>
        </Group>

        {/* <Paper
          my={"sm"}
          pl="md"
          style={{ borderLeft: "1px solid #C0C0C0", borderRadius: 0 }}
        >
          <Title
            order={5}
            style={{
              color: "rgb(0,0,0,0.7)",
              fontWeight: "700",
              marginBottom: "0px",
            }}
          >
            Benefits
          </Title>
          <Group spacing={3} noWrap>
            {data.benefits !== "" ? <Check color="green" /> : <X color="red" />}{" "}
            <Text weight={500}>Benefits</Text>
          </Group>
        </Paper> */}
      </SimpleGrid>

      {data?.jobType?.length > 1 && (
        <Paper mt="md">
          <Title
            order={4}
            style={{
              color: "rgb(0,0,0,0.7)",
              fontWeight: "700",
            }}
          >
            {data.jobType.length > 1 ? "Job Types" : "Job Type"}
          </Title>
          <Group>
            {data?.jobType?.map((type) => (
              <Badge size="lg" my="sm">
                <Group spacing={3} align="center">
                  <Clock color="green" size={20} />
                  <Text>{type?.jobType.lookupName}</Text>
                </Group>
              </Badge>
            ))}
          </Group>
        </Paper>
      )}
      {data?.jobType?.length > 1 && (
        <Paper mt="md">
          <Title
            order={4}
            style={{
              color: "rgb(0,0,0,0.7)",
              fontWeight: "700",
            }}
          >
            Job{data.industries.length > 1 ? " Industries" : " Industry"}
          </Title>
          <Group spacing={3}>
            {data?.industries?.map((ind) => (
              <Badge size="lg" my="sm">
                <Group spacing={3} align="center" noWrap>
                  <BuildingWarehouse color="green" size={20} />
                  <Text>{ind.industry.industryName}</Text>
                </Group>
              </Badge>
            ))}
          </Group>
        </Paper>
      )}

      <Divider my={"lg"} />
      <Title
        my={"sm"}
        order={4}
        style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}
      >
        Job Qualifications
      </Title>
      <Title
        order={5}
        style={{
          color: "rgb(0,0,0,0.7)",
          fontWeight: "700",
          marginBottom: "0px",
        }}
      >
        Required Job Skills
      </Title>
      <Group spacing={3}>
        {data?.skills?.map((skill) => (
          <Badge size="lg" my="sm">
            {skill.skills.skillName}
          </Badge>
        ))}
      </Group>
      <Title
        order={5}
        style={{
          color: "rgb(0,0,0,0.7)",
          fontWeight: "700",
          marginBottom: "0px",
        }}
      >
        Education
      </Title>
      <Text>{data?.education?.lookupName}</Text>
      <Divider my={"lg"} />
      <Paper>
        <Title order={4} style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}>
          Job Benefits
        </Title>
        <Text>{data?.benefits}</Text>
      </Paper>
      <Divider my={"lg"} />
      <Paper>
        <Title order={4} style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}>
          Job Description
        </Title>
        <Text>{data?.jobDescription}</Text>
      </Paper>
      {/* </div> */}
    </Paper>
  );
};

export default SpecificJobView;
